import * as Moment from "moment";

// 默认UTC偏移量
let UTC_OFFSET;

// moment()或moment(undefined)获取到的应是账户所选时区的当前时间，若有传值如moment('2020-05-03')，则不设置偏移量
export function moment(...args){
  if (args.length && !(args.length === 1 && args[0] === undefined)) {
    return Moment.apply(null, args);
  }
  if (UTC_OFFSET === undefined) {
    console.error('UTC_OFFSET INIT ERROR');
    return Moment();
  }
  return Moment().utcOffset(UTC_OFFSET);
}

// 设置UTC偏移量
export function setUtcOffset(offset){
  UTC_OFFSET = offset;
}
